function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m23.726-89.191 1.334-.685a.623.623 0 0 1 .834.266.623.623 0 0 1-.266.834l-1.334.685a.617.617 0 0 1-.562-1.1zm-1.519.556v-1.235a.618.618 0 0 0-1.235 0v1.235a.618.618 0 0 0 1.235 0zm-4.656-.142 1.334.685a.625.625 0 0 0 .834-.266.623.623 0 0 0-.266-.834l-1.334-.685a.617.617 0 0 0-.562 1.1zm3.532 14.041a.624.624 0 0 0 1.013 0l6.125-8.7H14.958zm7.459-10-1.661-1.828a.618.618 0 0 0-.457-.2h-9.67a.618.618 0 0 0-.457.2l-1.661 1.828a.434.434 0 0 0-.043.062h13.992a.389.389 0 0 0-.043-.062z",
  transform: "translate(-14.593 90.477)"
}));

function SvgFilledDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.992 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledDiamond);
export default __webpack_public_path__ + "static/media/filled_diamond.d1d4dc2c.svg";
export { ForwardRef as ReactComponent };